import styled from "@emotion/styled";
import {
  BrandCheckList,
  CategoryInput,
  ProductNameInput,
} from "@pages/register/_components/index";
import BasicButton from "@components/button/BasicButton";
import { useFormContext } from "react-hook-form";
import useProductEditStepStore from "@store/productEdit/useProductEditStepStore";
import CustomTextInput from "@components/input/CustomTextInput";
import BasicFormInput from "@components/input/BasicFormInput";
import { Flex } from "antd";

const Container = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: "3rem",
});

const ProductEditStepOne = () => {
  const { watch, trigger } = useFormContext();

  const { increaseStep } = useProductEditStepStore();

  const valid = async () => {
    // 현재 스텝의 필드들만 검증
    const isStepValid = await trigger(["name_ko", "depth1", "brand_id"]);

    if (isStepValid) {
      increaseStep();
    }
  };

  return (
    <Container>
      <ProductNameInput />

      <BrandCheckList />

      <Flex vertical gap={"1rem"}>
        <CustomTextInput name="depth1_name" readOnly />
        {watch("depth2_name") && (
          <CustomTextInput name="depth2_name" readOnly />
        )}
        {watch("depth3_name") && (
          <CustomTextInput name="depth3_name" readOnly />
        )}
        {watch("depth4_name") && (
          <CustomTextInput name="depth4_name" readOnly />
        )}
      </Flex>

      <BasicButton
        title="다음"
        height="5.2rem"
        width="100%"
        padding="1.6rem 1.2rem"
        // disabled={!name_ko || !depth1 || !brand_id}
        onClick={valid}
      />
    </Container>
  );
};

export default ProductEditStepOne;
